import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { CssBaseline }  from '@material-ui/core';
import Main from './Main';

import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import './locales/i18n';

Sentry.init({
    dsn: 'https://6f33680d145f45c280c065dae76485f5@o507301.ingest.sentry.io/5872523',
    integrations: [new Integrations.BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
});

ReactDOM.render(
    <BrowserRouter>
        <React.Fragment>
            <CssBaseline />
            <Main/>
        </React.Fragment>
    </BrowserRouter>,
    document.getElementById('root')
);



// WEBPACK FOOTER //
// ./resources/assets/js/app.js